import { mewsIconsetWoff, mewsIconsetWoff2 } from '@mews/iconset';
import { createGlobalStyle } from '@optimus-web/core';
import { createFontFaceCSS } from '../../utils';

export const MEWS_ICONS_FONT_FAMILY = 'Mews Icons';
const mewsIconsetPaths = [
    { format: 'woff', path: mewsIconsetWoff },
    { format: 'woff2', path: mewsIconsetWoff2 },
];

export const getIconsetCSS = (baseUrl = '') =>
    createFontFaceCSS({ name: MEWS_ICONS_FONT_FAMILY, baseUrl, paths: mewsIconsetPaths, fontDisplay: 'block' });

export const getIconsetStyles = (baseUrl = '') => createGlobalStyle`
    ${getIconsetCSS(baseUrl)}
`;

export const reportMissingIcons = (errorHandler: (error: Error) => void) => {
    if (!window.document.fonts) {
        return;
    }

    window.document.fonts.onloadingerror = (fontFaceSetEvent) => {
        const iconsFont = (fontFaceSetEvent as $TSFixMe).fontfaces.find(
            (fontface: FontFace) => fontface.family === MEWS_ICONS_FONT_FAMILY
        );
        if (iconsFont) {
            iconsFont.loaded.catch(errorHandler);
        }
    };
};
